module.exports = __webpack_public_path__ + "img/productivity-summary.6b01e89c.png";